/* LH - red de seguridad para las animaciones de entrada.
   El tema oculta todo lo que trae [data-reveal] (opacity:0) y un IntersectionObserver
   les agrega .is-visible al entrar en pantalla. Cuando ese observer no corre
   (orden de carga, scripts diferidos, vistas previas) la pagina se queda EN BLANCO.
   Esto revela lo que ya esta en pantalla, sigue animando lo de abajo al hacer scroll,
   y a los 2.5s revela cualquier cosa que haya quedado oculta. */
(function () {
  var SEL = '.lh-home-main [data-reveal]:not(.is-visible)';

  function revelarCercanos() {
    var limite = window.innerHeight * 1.15;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < limite) els[i].classList.add('is-visible');
    }
  }

  function revelarTodo() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
  }

  function arrancar() {
    revelarCercanos();
    var pendiente = null;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; revelarCercanos(); }, 80);
    }, { passive: true });
    window.addEventListener('resize', revelarCercanos, { passive: true });
    setTimeout(revelarCercanos, 400);
    setTimeout(revelarCercanos, 1200);
    setTimeout(revelarTodo, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  window.addEventListener('load', revelarCercanos);
})();
